/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import { wrapPageElement as wrap } from "./src/page-wrapper"
import React, { useEffect } from 'react';

// export const shouldUpdateScroll = ({
//   routerProps: { location, prevLocation },
//   getSavedScrollPosition,
// }) => {
//   // 戻る操作の場合、falseを返す
//   if (prevLocation && location.key === prevLocation.key) {
//     return false; // 戻る操作時にスクロールを更新しない
//   }

//   // それ以外の操作（通常のページ遷移）はスクロール位置を保存する
//   // const currentPosition = getSavedScrollPosition(location);

//   // console.log("currentPosition result:", currentPosition);

//   // // currentPosition を sessionStorage に保存
//   // sessionStorage.setItem("scrollPosition", JSON.stringify(currentPosition));

//   // return true; // 戻る操作以外ではスクロール位置を更新
// };

// gatsby-browser.js
let isBackOrForward = false;

window.addEventListener('popstate', () => {
  isBackOrForward = true;
});

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location !== prevLocation) {
    if (isBackOrForward) {
      // 戻る/進むの場合は前のページのスクロール位置を復元
      const savedPosition = sessionStorage.getItem(`scrollPos-${location.pathname}`);
      if (savedPosition) {
        const [, y] = JSON.parse(savedPosition);
        window.setTimeout(() => {
          window.scroll({ left: 0, top: y, behavior: 'instant' });
        }, 100);
      }
      isBackOrForward = false;
    } else {
      // 通常のクリック遷移は常にトップへ
      window.scrollTo(0, 0);
    }
  }
};


const ScrollManager = ({ location }) => {
  useEffect(() => {
    const saveScroll = () => {
      console.log(window.pageYOffset)
      sessionStorage.setItem(
        `scrollPos-${location.pathname}`,
        JSON.stringify([window.pageXOffset, window.pageYOffset])
      );
    };

    window.addEventListener('scroll', saveScroll);
    return () => window.removeEventListener('scroll', saveScroll);
  }, [location]);

  return null;
};

export const wrapPageElement = ({ element, props }) => (
  <>
    <ScrollManager location={props.location} />
    {element}
  </>
);

// export const wrapPageElement = wrap
